<template>
<div class="selection-question">
  <div>
    <img v-if="node.question.image !== null" :src="node.question.image" class="question-image" />
    <p v-if="node.prompt !== null" v-html="node.prompt"></p>
    <div v-html="node.question.instructions"></div>
    <v-select
      @change="onChangeSelection"
      :items="filteredOptions"
      item-text="label"
      item-value="id"
      v-model="selection"
      outlined
    ></v-select>
    <img v-if="selection !== null && selection.image !== null"
      class="selection-image" :src="selection.image"/>
  </div>
  <div class="buttons">
    <v-btn
      class="submit-button"
      :disabled="!isValidSelection()"
      color="primary"
      @click="onAnswerQuestion">
      {{ submitButton }}
    </v-btn>
    <v-btn
      v-if="node.skippable"
      class="submit-button"
      color="secondary"
      @click="onSkipQuestion">
      {{ skipButton }}
    </v-btn>
  </div>
</div>
</template>

<script>
import optionFilterMixin from '../mixins/optionFilterMixin';

export default {
  name: 'SelectionQuestion',
  mixins: [optionFilterMixin],
  data() {
    const options = {};

    this.node.question.options.forEach((item) => {
      options[item.id] = item;
    });

    return {
      selection: null,
      options,
    };
  },
  computed: {
    filteredOptions() {
      return this.getFilteredOptions(this.node, this.node.question.options);
    },
  },
  methods: {
    isValidSelection() {
      if (this.selection !== null) {
        return true;
      }
      return false;
    },
    onAnswerQuestion() {
      this.$emit('answer', {
        node: this.node,
        id: this.selection.id,
        value: this.selection.value,
        text: this.selection.label,
      });
      this.selection = null;
    },
    onSkipQuestion() {
      this.$emit('skip');
      this.selection = null;
    },
    onChangeSelection(id) {
      this.selection = this.options[id];
    },
  },
  props: {
    node: Object,
    submitButton: String,
    skipButton: String,
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables.scss";

.selection-question {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100%;
  padding: 1.5rem 1.5rem 1.5rem 1.5rem;

  .question-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
    margin-bottom: 2rem;
  }

  .selection-image {
    display: block;
    max-width: 340px;
    margin-left: auto;
    margin-right: auto;
  }

  .buttons {
    display: flex;
    width: 100%;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-self: center;
  }
}

@media (min-width: $breakpoint-tablet) {
  .selection-question {
    justify-content: flex-start;

    .buttons {
      margin-top: 3rem;
    }
  }
}
</style>
